import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  GoogleTagManagerAutoStyled,
  GoogleTagManagerAutoSuccess,
  GoogleTagManagerAutoText,
} from 'Features/domainsManagement/components/GetTagModal/components/Instructions/GoogleTagManager/GoogleTagManagerAuto/GoogleTagManagerAuto.styled'
import { Button } from '@clickcease/cc-client-components-lib'
import { GOOGLE_CLIENT_ID } from 'Consts/google'
import { GoogleTagManagerModal } from 'Features/domainsManagement/components/GetTagModal/components/Instructions/GoogleTagManager/GoogleTagManagerModal/GoogleTagManagerModal'
import { queryClient } from 'Lib/react-query'
import { Domain } from 'Types/Domain'
import { FlexColumn, FlexRow } from 'Providers/app.styled'
import { TOASTS } from 'Components/Elements/Toaster/Toast.models'
import { useAppStore } from 'Stores/appStoreModuleFed'

type GoogleTagManagerAutoProps = {
  domain: Domain | undefined
  noMargin?: boolean
  fullSizeButton?: boolean
}

const scopes = [
  'https://www.googleapis.com/auth/tagmanager.edit.containers',
  'https://www.googleapis.com/auth/tagmanager.readonly',
  'https://www.googleapis.com/auth/tagmanager.manage.accounts',
  'https://www.googleapis.com/auth/tagmanager.publish',
  'https://www.googleapis.com/auth/tagmanager.edit.containerversions',
]

export const GoogleTagManagerAuto = ({
  domain,
  noMargin,
  fullSizeButton,
}: GoogleTagManagerAutoProps) => {
  const { t } = useTranslation('domainManagement')
  const [showGtmModal, setShowGtmModal] = useState<boolean>(false)
  const [googleToken, setGoogleToken] = useState<string>('')
  const [isPublish, setIsPublish] = useState<boolean>(false)
  const { showToaster } = useAppStore()

  const googleInit = window.google.accounts.oauth2.initTokenClient({
    client_id: GOOGLE_CLIENT_ID,
    scope: scopes.join(' '),
    callback: (response) => {
      void queryClient.invalidateQueries(['gtmAccounts'])
      setGoogleToken(response.access_token)
      setShowGtmModal(true)
    },
  })

  const closeModal = (success: boolean, publish: boolean) => {
    setShowGtmModal(false)
    setGoogleToken('')
    setIsPublish(publish)
    if (success) {
      showToaster(
        t(publish ? 'gtm_auto.added_successfully' : 'gtm_auto.added_to_workspace'),
        TOASTS.success
      )
    }
  }

  return (
    <GoogleTagManagerAutoStyled noMargin={noMargin}>
      <FlexColumn>
        <FlexRow>
          <GoogleTagManagerAutoText>{t('gtm_auto.direct_installation')}</GoogleTagManagerAutoText>
          {domain?.gtmImplemented && (
            <GoogleTagManagerAutoSuccess>
              {t(isPublish ? 'gtm_auto.tag_installed' : 'gtm_auto.tag_pending')}
            </GoogleTagManagerAutoSuccess>
          )}
        </FlexRow>
        <Button
          size={'md'}
          css={fullSizeButton ? { width: '100%' } : undefined}
          loading={false}
          text={t('gtm_auto.connect_with_gtm')}
          onClick={() => {
            googleInit.requestAccessToken()
          }}
        />
      </FlexColumn>
      {showGtmModal && (
        <GoogleTagManagerModal
          isOpen={true}
          setIsOpen={closeModal}
          googleToken={googleToken}
          domain={domain}
        />
      )}
    </GoogleTagManagerAutoStyled>
  )
}
